import { render } from "./SettingsUserCategories.vue?vue&type=template&id=7ef638a0&scoped=true"
import script from "./SettingsUserCategories.vue?vue&type=script&lang=js"
export * from "./SettingsUserCategories.vue?vue&type=script&lang=js"

import "./SettingsUserCategories.vue?vue&type=style&index=0&id=7ef638a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef638a0"]])

export default __exports__